import React, { FC, forwardRef } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { MuiCheckboxProps } from './types';

const MuiCheckbox: FC<MuiCheckboxProps> = forwardRef<HTMLButtonElement, MuiCheckboxProps>(
	({ disabled, color, checked, value, classes, ...restProps }, ref) => {
		return (
			<Checkbox
				ref={ref}
				value={value}
				checked={checked}
				disabled={disabled}
				color={color}
				disableRipple
        disableFocusRipple
        {...restProps}
			/>
		);
	}
);

export default MuiCheckbox;
